import { useEffect } from "react";
import { auth, onAuthStateChanged, db, doc, getDoc, setDoc } from "../lib/firebase";
import { useAuthStore } from "../stores/authStore";
import type { UserProfile } from "../types";

export function useAuthListener() {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      const { setUser, setLoading } = useAuthStore.getState();

      if (!firebaseUser) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        const userRef = doc(db, "users", firebaseUser.uid);
        const userSnap = await getDoc(userRef);

        let currentPartyId: string | null = null;

        if (userSnap.exists()) {
          currentPartyId = userSnap.data()?.currentPartyId || null;
        } else {
          // Initialize user doc
          await setDoc(userRef, {
            displayName: firebaseUser.displayName || "Guest Singer",
            email: firebaseUser.email || null,
            photoURL: firebaseUser.photoURL || null,
            isAnonymous: firebaseUser.isAnonymous,
            createdAt: new Date().toISOString(),
          }, { merge: true });
        }

        const profile: UserProfile = {
          uid: firebaseUser.uid,
          displayName: firebaseUser.displayName || (firebaseUser.isAnonymous ? "Guest Singer" : "Karaoke Fan"),
          firstName: (firebaseUser.displayName || "Guest").split(" ")[0],
          photoURL: firebaseUser.photoURL || `https://api.dicebear.com/7.x/bottts/svg?seed=${firebaseUser.uid}`,
          email: firebaseUser.email || null,
          isAnonymous: firebaseUser.isAnonymous,
          currentPartyId,
        };

        setUser(profile);
      } catch (error) {
        console.error("Error setting up user profile:", error);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);
}
